<template>
    <vx-card class="p-2" :title="title" :title-color="titleColor">
        <div class="format_my_advisor_on_small_screens">
        <router-link :to="{name: 'user-info', query: {id: item.uid}}">
            <vs-avatar class="mx-auto mb-6 block format_my_advisor_on_small_screens__avatar" size="80px" :src="item.avatar" />
        </router-link>
        <div class="text-center  format_my_advisor_on_small_screens__name">
            <h4
                class="cursor-pointer"
                @click="goToProfile({id: item.uid})" >
                {{ item.full_name }}
            </h4>

            <p class="text-grey" v-if="item.email">
                <a class="break-all text-black"   :href="`mailto:${ item.email }`">{{item.email}}</a>
            </p>
        </div>
        <div class="flex justify-around flex-wrap" v-if="$store.state.user.roles.is_student == true">
            <vx-tooltip color="primary" :text="$t('write_a_message')">
                <vs-button
                    radius
                    v-if="user.profileId !== item.profileId"
                    color="#7367F0"
                    @click="advisorMessage()"
                    icon-pack="feather"
                    icon="icon-message-square"
                    size="small"
                    class="mt-4 format_my_advisor_on_small_screens__buttons"
                    type="flat">
                </vs-button>
            </vx-tooltip>
            <vx-tooltip color="primary"  :text="$t('history_adviser')">
                <vs-button
                    radius
                    v-if="user.profileId !== item.profileId"
                    color="#7367F0"
                    @click="openChangeVisor('openStoryVisor')"
                    icon-pack="feather"
                    size="small"
                    class="mt-4 px-2 mx-2 format_my_advisor_on_small_screens__buttons"
                    type="flat">
                    <feather-icon  color="primary" icon="AlertOctagonIcon" svgClasses="h-4 w-4"/>
                </vs-button>
            </vx-tooltip>
        </div>
            </div>
    </vx-card>

</template>

<script>
import {mapState} from 'vuex'
import CommonMixin from "./CommonMixin";
export default {
    mixins:[CommonMixin],
    props: {
        title: {
            type: String,
            default: ''
        },
        titleColor: {
            type: String,
            default: ''
        },
        item:{
            type:Object,
            default:{
                role:{
                    is_supervisor:false,
                }
            }
        },
    },
    data() {
        return {
            check_allow_change_adviser:true
        }
    },
    async mounted() {
    },
    async created() {
        await this.requestData()
    },
    methods: {

        async requestData(){
            var obj = (await this.$http.get('/common/allow_change_adviser/')).data
            if (obj.length > 0)
                this.check_allow_change_adviser = obj[0].allow_change_adviser
        },
        advisorMessage() {
            this.$router.push({name: 'chat', query: {user: this.$store.state.user.user.supervisors.uid}})
        },
        openChangeVisor(fn_name){
            this.$emit(fn_name,true);
        }
    },

    computed: {
        ...mapState({
            user: state => state.user.user
        }),
        userName() {
            // Возвращаем имя человека целиком
            return `${ this.item.lastName } ${ this.item.firstName } ${ this.item.middleName }`
        },
        avatarText() {
            // Если нет аватара подставляем инициалы
            let title,
                text = this.userName
            const textAr = text.split(' ')
            if (textAr.length) {
                const newTitle = []
                textAr.forEach(item => {
                    newTitle.push(item.substr(0, 1).toUpperCase())
                })
                title = newTitle.join('')
            } else title = text.substr(0, 1)
            return title
        },
        is_supervisor(){
            return this.item.role?
                this.item.role.is_supervisor?true:false
                :false;
        }
    }
}
</script>

<style scoped lang="scss">
@media only screen and (min-width: 1000px) and (max-width: 1460px) {
    .user_label{
        display: block!important;
    }
}
@media only screen and (max-width: 600px){
    .format_my_advisor_on_small_screens{
        align-items: center !important;
        display: flex !important;
        justify-content: space-around !important;
    }
    .format_my_advisor_on_small_screens__avatar{
        margin-bottom: 0rem !important;
        margin-top: 0rem !important;

    }
    .format_my_advisor_on_small_screens__name{
        padding-right: 20px !important;
        padding-left: 20px !important;
    }
    .format_my_advisor_on_small_screens__buttons{
        margin-top: 0rem !important;
    }


}

</style>
